module.exports = " <div von-nav v-show=!hideNavbar transition=nav-fade class=navbar> <div v-if=showBackButton class=back-button @click=backButtonClicked($event) transition=fade> {{{ backButtonText }}} </div> <div v-if=showMenuButton class=menu-button @click=menuButtonClicked($event) transition=fade> {{{ menuButtonText }}} </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Navbar.vue
// module id = 229
// module chunks = 0